import { CalendarSortingState } from './state';
import { SortOrder, ColumnSortModel } from '../../grid/types/sorting.types';
import {
  CalendarSortingActionUnion,
  CalendarSortingActionTypes
} from './actions';
import { CalendarGridColumnName } from '../../grid/types/column.types';

export const initialCalendarSortingState: CalendarSortingState = {
  sortModel: [
    {
      colId: CalendarGridColumnName.Size,
      sort: SortOrder.Desc
    }
  ]
};
export function calendarSortingReducer(
  state: CalendarSortingState = initialCalendarSortingState,
  action: CalendarSortingActionUnion
) {
  switch (action.type) {
    case CalendarSortingActionTypes.SetModel:
      return {
        ...state,
        sortModel: action.payload
      };
    default:
      return state;
  }
}

export const getCalendarSortModel = (
  state: CalendarSortingState
): ColumnSortModel<CalendarGridColumnName>[] => {
  return state.sortModel;
};
